{
  "name": "INB",
  "logo": {
    "_1x": "logo1x.png",
    "_2x": "logo2x.png",
    "_3x": "logo3x.png"
  },
  "authLogo": {
    "_1x": "authLogo1x.png",
    "_2x": "authLogo2x.png",
    "_3x": "authLogo3x.png"
  },
  "background": {
    "_1x": "bg1x.png",
    "_2x": "bg2x.png",
    "_3x": "bg3x.png"
  },
  "uiKit": {
    "colors": {
      "theme": {
        "brand": {
          "lightest": "#6EC5DB",
          "lighter": "#3BABCF",
          "primary": "#039AC7",
          "darker": "#046083",
          "darkest": "#141D28"
        },
        "gradient": {
          "login": "linear-gradient(200deg, #3BABCF 0%, #039AC7 100%)"
        },
        "positive": {
          "main": "#C0D72D",
          "darker": "#9AAC24",
          "darkest": "#73811B"
        }
      }
    },
    "borderRadius": {
      "default": "4px",
      "roundedModal": "12px"
    },
    "typography": {
      "bodyM": {
        "button": {
          "fontFamily": "Source Sans Pro",
          "fontWeight": "700",
          "lineHeight": "16px",
          "fontSize": "14px",
          "letterSpacing": "0.2px",
          "paragraphSpacing": "0px",
          "textCase": "capitalize",
          "textDecoration": "none"
        }
      },
      "bodyL": {
        "buttonL": {
          "fontFamily": "Source Sans Pro",
          "fontWeight": "700",
          "lineHeight": "20px",
          "fontSize": "16px",
          "letterSpacing": "0.2px",
          "paragraphSpacing": "0px",
          "textDecoration": "none",
          "textCase": "capitalize"
        }
      }
    }
  }
}
